// @flow

import partition from 'lodash.partition';
import memoize from 'lodash.memoize';

import type {RowData, SplitByPinnedRowsData} from '../typedef';

const prepareSplitByPinnedRows = <DataRow>(rows: Array<RowData<DataRow>>): SplitByPinnedRowsData<DataRow> => {
    const [pinnedRows, ordinaryRows] = partition(rows, {pinned: true});
    return {pinnedRows, ordinaryRows};
};

export const splitByPinnedRows: <DataRow>(rows: Array<RowData<DataRow>>) => SplitByPinnedRowsData<DataRow> =
    memoize<Array<Array<RowData<Object>>>, SplitByPinnedRowsData<Object>>(prepareSplitByPinnedRows);

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("../typedef");
